import React, { useState, useEffect } from "react";
import classes from "./LoanAppModalExcel.module.css";
import api, { withCompanyId } from "../../Components/API/Api";
import { useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import crop from "../../Assets/repoort.png";
import verified from "../../Assets/verified.svg";
import CurrencyInput from 'react-currency-input-field';

function LoanAppModalExcel({ isOpen, onClose, onSuccess }) {
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);

  const [reference, setReference] = useState("");
  const [duration, setDuration] = useState("");
  const [interestAmount, setInterestAmount] = useState(0.00);
  const [monthlyDeduction, setMonthlyDeduction] = useState(0.00);
  const [repaymentAmount, setRepaymentAmount] = useState(0.00);
  const [loanInterest, setLoanInterest] = useState('');
  const [fetchedLoanInterest, setFetchedLoanInterest] = useState(0.00);
  const [supplierSearch, setSupplierSearch] = useState("");
  const [showSupplierDropdown, setShowSupplierDropdown] = useState(false);
  const navigate = useNavigate();
  const [debitSearch, setDebitSearch] = useState("");
  const [showDebitDropdown, setShowDebitDropdown] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [description, setDescription] = useState("");
  const [debitAccount, setDebitAccount] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [loanOptions, setLoanOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [paymentToLoading, setPaymentToLoading] = useState(false);
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  const [creditAccounts, setCreditAccounts] = useState([]);
const [loanProducts, setLoanProducts] = useState([]);
const [selectedLoanProducts, setSelectedLoanProducts] = useState('');
const [loanProductsLoading, setLoanProductsLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(""); 
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);
  const [paymentSearch, setPaymentSearch] = useState("");
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false);
  const [expenseOptions, setExpenseOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [receiptType, setReceiptType] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);
  const [supportingDocument, setSupportingDocument] = useState(null);
  const [supportingError, setSupportingError] = useState("");
  const [payableAccounts, setPayableAccounts] = useState([]);
  const [payableAccountsLoading, setPayableAccountsLoading] = useState(false);
  const [pendingInvoicesMap, setPendingInvoicesMap] = useState({});

  const handleFileChange = (e) => {
  const file = e.target.files?.[0];
  
  // 1. Handle clear/empty selection
  if (!file) { 
    setSupportingDocument(null); 
    setSupportingError(""); 
    return; 
  }

  // 2. Define valid Excel MIME types and extensions
  const validExcelTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "application/vnd.ms-excel" // .xls
  ];
  const isExcelExtension = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');

  // 3. Validate file type (checking both MIME type and extension for safety across OS)
  if (!validExcelTypes.includes(file.type) && !isExcelExtension) { 
    setSupportingError('Only Excel files (.xlsx, .xls) are allowed.'); 
    setSupportingDocument(null); 
    return; 
  }

  // 4. Validate file size (2MB limit)
  const max = 2 * 1024 * 1024;
  if (file.size > max) { 
    setSupportingError('File must be 2MB or smaller.'); 
    setSupportingDocument(null); 
    return; 
  }

  // 5. Success
  setSupportingError(""); 
  setSupportingDocument(file);
};

  // === Reset all form fields to initial state ===
  const resetFormFields = () => {
    setRows([
      { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
    ]);
    setReference("");
    setSupplierSearch("");
    setShowSupplierDropdown(false);
    setDebitSearch("");
    setShowDebitDropdown(false);
    setTransactionDate("");
    setDescription("");
    setDebitAccount("");
    setOutstandingAmount("");
    setSelectedLoanAccount("");
    setSelectedPaymentType("");
    setPaymentSearch("");
    setShowPaymentDropdown(false);
    setTotalAmount("");
    setSelectedCurrency("");
    setSelectedPaymentMode("");
    setSupportingDocument(null);
    setSupportingError("");

    // Set NGN as default currency if available
    const ngnCurrency = currencyOptions.find(c => c.code === "NGN");
    if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
  };

  // keep handlePrinter as-is
  const handlePrinter = () => {
    const receiptData = {
      reference,
      transactionDate,
      description,
      selectedCurrency,
      selectedPaymentMode,
      debitAccount,
      totalAmount,
      rows,
    };

    navigate("/preview", {
      state: { invoice: receiptData },
    });
  };

  // --- Update outstandingAmount when reference (customer selection) changes ---
  useEffect(() => {
    if (!receiptType?.toLowerCase()?.includes("credit customer")) {
      setOutstandingAmount("");
      return;
    }

    if (!reference) {
      setOutstandingAmount("");
      return;
    }

    const customerObj = customerOptions.find(c => String(c.id) === String(reference));
    const balance = customerObj?.balance ?? 0;
    setOutstandingAmount(String(Number(balance) || 0));
  }, [reference, customerOptions, receiptType]);

  // --- Auto-fill totalAmount when supplier is selected for "payment from payables" ---
  useEffect(() => {
    const type = (selectedPaymentType || "").toLowerCase().trim();
    
    if (!type.includes("payment from payables")) {
      return;
    }

    if (!reference) {
      setTotalAmount("");
      setRows((prev) => {
        if (!prev.length) return prev;
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: "",
        };
        return newRows;
      });
      return;
    }

    const invoiceData = pendingInvoicesMap[reference];
    if (invoiceData) {
      const balance = String(invoiceData.balance || 0);
      setTotalAmount(balance);
      setRows((prev) => {
        if (!prev.length) {
          return [{ accountId: "", accountDisplay: "", accountCode: "", amount: balance, showDropdown: false }];
        }
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: balance,
        };
        return newRows;
      });
    } else {
      setTotalAmount("");
      setRows((prev) => {
        if (!prev.length) return prev;
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: "",
        };
        return newRows;
      });
    }
  }, [reference, pendingInvoicesMap, selectedPaymentType]);

  // --- Auto-fill Account Name and Account Code when invoice is selected for "payment from payables" ---
  useEffect(() => {
    const type = (selectedPaymentType || "").toLowerCase().trim();
    
    if (!type.includes("payment from payables")) {
      return;
    }

    if (!reference) {
      // Reset first row when no reference is selected
      setRows((prev) => {
        const newRows = [...prev];
        if (newRows[0]) {
          newRows[0] = {
            ...newRows[0],
            accountId: "",
            accountDisplay: "",
            accountCode: "",
          };
        }
        return newRows;
      });
      return;
    }

    const invoiceData = pendingInvoicesMap[reference];
    if (invoiceData && invoiceData.fullInvoice) {
      const invoice = invoiceData.fullInvoice;
      
      // Get items from invoice (try multiple field names)
      let items = invoice.items || invoice.line_items || invoice.purchase_order_items || invoice.invoice_items || [];
      
      if (Array.isArray(items) && items.length > 0) {
        const firstItem = items[0];
        
        // Get account information from the first item
        let account = null;
        
        // Try to get account from different possible locations
        if (firstItem.account && typeof firstItem.account === 'object') {
          account = firstItem.account;
        } else if (firstItem.debit_gl && typeof firstItem.debit_gl === 'object') {
          account = firstItem.debit_gl;
        }
        
        if (account) {
          const gl_name = account.gl_name || account.name || account.account_name || "";
          const gl_code = account.gl_code || account.code || "";
          const accountId = account.id || "";
          
          // Update the first row with auto-filled account information
          setRows((prev) => {
            const newRows = [...prev];
            if (newRows[0]) {
              newRows[0] = {
                ...newRows[0],
                accountId: accountId,
                accountDisplay: gl_name,
                accountCode: gl_code,
              };
            }
            return newRows;
          });
          
          console.log("✅ Auto-filled account from invoice item:", {
            gl_name,
            gl_code,
            accountId,
          });
        }
      }
    }
  }, [reference, pendingInvoicesMap, selectedPaymentType]);

  // --- Fetch customers (only when receiptType includes credit customer) ---
  useEffect(() => {
    const fetchCustomers = async () => {
      if (!receiptType?.toLowerCase()?.includes("credit customer")) return;

      try {
        setCustomerLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/customer/get');

        if (res.data && Array.isArray(res.data.data)) {
          setCustomerOptions(res.data.data);
        } else {
          setCustomerOptions([]);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        setCustomerOptions([]);
      } finally {
        setCustomerLoading(false);
      }
    };

    fetchCustomers();
  }, [receiptType]);

  // --- Fetch loans (when receiptType includes loan repayment) ---
  useEffect(() => {
    const fetchLoanOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("loan repayment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/loans');

        if (res.data && Array.isArray(res.data.data)) {
          setLoanOptions(res.data.data);
        } else {
          setLoanOptions([]);
        }
      } catch (err) {
        console.error("Error fetching loans:", err);
        setLoanOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchLoanOptions();
  }, [receiptType]);

  // --- Fetch employees (when receiptType includes employee payment) ---
  useEffect(() => {
    const fetchEmployeeOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("employee payment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/employee/paginated');

        // Handle paginated response: { status, message, data: { current_page, data: [...], ... } }
        if (res.data && res.data.data?.data && Array.isArray(res.data.data.data)) {
          setEmployeeOptions(res.data.data.data);
        } else {
          setEmployeeOptions([]);
        }
      } catch (err) {
        console.error("Error fetching employees:", err);
        setEmployeeOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchEmployeeOptions();
  }, [receiptType]);

  // --- Fetch payment types ---
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      setPaymentTypesLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/member', { params: { name: 'payment' } });
        if (res.data && Array.isArray(res.data.data)) {
          setPaymentTypes(res.data.data);
        } else {
          setPaymentTypes([]);
        }
      } catch (err) {
        setPaymentTypes([]);
      } finally {
        setPaymentTypesLoading(false);
      }
    };
    fetchPaymentTypes();
  }, []);

  useEffect(() => {
    const fetchLoanProducts = async () => {
      setLoanProductsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/loan_account');
        if (res.data && Array.isArray(res.data.data)) {
          setLoanProducts(res.data.data);
        } else {
          setLoanProducts([]);
        }
      } catch (err) {
        setLoanProducts([]);
      } finally {
        setLoanProductsLoading(false);
      }
    };
    fetchLoanProducts();
  }, []);

 useEffect(() => {
  const principal = Number(
    String(totalAmount || "0").replace(/,/g, "")
  );

  const rate = Number(loanInterest || 0);

  const interest = (rate / 100) * principal;

  setInterestAmount(
    isNaN(interest)
      ? "0.00"
      : interest.toFixed(2)
  );
}, [loanInterest, totalAmount]);
    
    
    useEffect(() => {
  const principal = Number(
    String(totalAmount || "0").replace(/,/g, "")
  );

  const interest = Number(
    String(interestAmount || "0").replace(/,/g, "")
  );

  const totalRepayment = principal + interest;

  setRepaymentAmount(
    isNaN(totalRepayment)
      ? "0.00"
      : totalRepayment.toFixed(2)
  );
}, [totalAmount, interestAmount]);
    
    useEffect(() => {
  const repayment = Number(
    String(repaymentAmount || "0").replace(/,/g, "")
  );

  const months = Number(duration || 0);

  if (!months) {
    setMonthlyDeduction("0.00");
    return;
  }

  const monthly = repayment / months;

  setMonthlyDeduction(
    isNaN(monthly)
      ? "0.00"
      : monthly.toFixed(2)
  );
}, [repaymentAmount, duration]);


  // --- Fetch suppliers when selectedPaymentType includes supplier or payable ---
  useEffect(() => {
    const fetchSuppliers = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      // Handle "payment from payables" - fetch from pending purchase invoices endpoint
      if (type.includes("payment from payables")) {
        setSupplierLoading(true);
        try {
          const token = localStorage.getItem("authToken");
          const res = await api.get('/v1/retrieve-pending-purchase-invoices');

          const invoices = res?.data?.data;
          if (Array.isArray(invoices)) {
            const invoiceMap = {};
            const options = [];
            const processedSuppliers = new Map();

            // Process invoices to group by supplier and create display options
            invoices.forEach((invoice) => {
              const invoiceId = String(invoice.id);
              const supplierName = invoice.supplier?.name || `Supplier ${invoice.supplier_id}`;
              const invoiceNumber = invoice.invoice_number;
              const balance = invoice.balance;
              
              // Store invoice data by its ID
              invoiceMap[invoiceId] = {
                id: invoiceId,
                invoiceId,
                supplierName,
                invoiceNumber,
                balance,
                fullInvoice: invoice,
              };

              // Create display option: "Supplier Name (Invoice Number)"
              const displayLabel = `${supplierName} (${invoiceNumber})`;
              options.push({
                id: invoiceId,
                name: displayLabel,
                balance,
              });
            });

            // Log invoice structure for debugging item extraction
            console.log("📦 Pending invoices API response structure:", {
              firstInvoice: invoices[0],
              allInvoices: invoices
            });

            setPendingInvoicesMap(invoiceMap);
            setSupplierOptions(options);
          } else {
            setPendingInvoicesMap({});
            setSupplierOptions([]);
          }
        } catch (err) {
          console.error("Error fetching pending purchase invoices:", err);
          setPendingInvoicesMap({});
          setSupplierOptions([]);
        } finally {
          setSupplierLoading(false);
        }
        return;
      }

      // Original logic for regular supplier selection
      if (!type.includes("supplier") && !type.includes("payable")) {
        setSupplierOptions([]);
        setPendingInvoicesMap({});
        return;
      }

      setSupplierLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/beneficiary');

        const suppliers = res?.data?.data;
        if (Array.isArray(suppliers)) {
          const options = suppliers.map((s) => ({
            id: s.id,
            name: s.supplier_name || s.name || `Supplier ${s.id}`,
          }));
          setSupplierOptions(options);
          setPendingInvoicesMap({});
        } else {
          setSupplierOptions([]);
          setPendingInvoicesMap({});
        }
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        setSupplierOptions([]);
        setPendingInvoicesMap({});
      } finally {
        setSupplierLoading(false);
      }
    };

    fetchSuppliers();
  }, [selectedPaymentType]);

  // --- Fetch Account Names and Codes ---
  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-expense-accounts');
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setAccounts(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchAccounts();
  }, []);

  // --- Fetch Payable Accounts when payment type includes "payable" ---
  useEffect(() => {
    const fetchPayableAccounts = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      if (!type.includes("payable")) {
        setPayableAccounts([]);
        return;
      }

      setPayableAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-payable-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          setPayableAccounts(res.data.data);
        } else {
          setPayableAccounts([]);
        }
      } catch (err) {
        console.error("Error fetching payable accounts:", err);
        setPayableAccounts([]);
      } finally {
        setPayableAccountsLoading(false);
      }
    };

    fetchPayableAccounts();
  }, [selectedPaymentType]);

  // --- Fetch Payment Methods ---
  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/income/get-payment-method');

        if (res.data && Array.isArray(res.data.data)) {
          setPaymentModes(res.data.data);
        } else {
          setPaymentModes([]);
        }
      } catch (err) {
        console.error("Error fetching payment methods:", err);
        setPaymentModes([]);
      }
    };
    fetchPaymentModes();
  }, []);

  // --- Fetch Currencies ---
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/fetch-all-currencies');

        if (res.data && Array.isArray(res.data.data)) {
          setCurrencyOptions(res.data.data);

          // ✅ Set NGN as default
          const ngnCurrency = res.data.data.find(c => c.code === "NGN");
          if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
        }
      } catch (err) {
        console.error("Error fetching currencies:", err);
      }
    };
    fetchCurrencies();
  }, []);

  useEffect(() => {
    const fetchCreditAccounts = async () => {
      setDebitAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/bank-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          const creditAccounts = res.data.data.map((acc) => ({
            value: acc.id,
            label: acc.gl_name || acc.name || acc.account_name,
            gl_code: acc.gl_code || acc.code,
            fullAccount: acc,
          }));
          setCreditAccounts(creditAccounts);
        } else {
          setCreditAccounts([]);
        }
      } catch (error) {
        console.error("Error fetching credit accounts:", error);
        setCreditAccounts([]);
      } finally {
        setDebitAccountsLoading(false);
      }
    };

    if (isOpen) fetchCreditAccounts();
  }, [isOpen]);

  if (!isOpen) return null;

  // === TABLE HANDLERS ===
  const addLine = () => {
    setRows((prev) => [
      ...prev,
      { accountId: "", accountDisplay: "", amount: "", showDropdown: false },
    ]);
  };

  const handleValueChange = (value, name, values) => {
      setTotalAmount(value);
    };
  const handleValueChange1 = (value, name, values) => {
      setInterestAmount(value);
    };
  const handleValueChange2 = (value, name, values) => {
      setRepaymentAmount(value);
    };
  const handleValueChange3 = (value, name, values) => {
      setMonthlyDeduction(value);
    };



  const duplicateRow = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const emptyRow = {
        accountId: "",
        accountDisplay: "",
        amount: "",
        showDropdown: false,
      };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = (index, field, value) => {
    setRows((prev) => {
      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "showDropdown") {
        row.showDropdown = value;
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_name ?? value?.name ?? ""}`;
        row.accountCode = value?.gl_code ?? value?.code ?? "";
        row.showDropdown = false;
      } else if (field === "accountDisplay") {
        row.accountDisplay = value;
        row.accountId = "";
        row.accountCode = "";
        row.showDropdown = true;
      } else if (field === "amount") {
        row.amount = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };

  const totalDebit = parseFloat(totalAmount || 0);
  const totalCredit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );
  const isBalanced = totalDebit === totalCredit;

  // === handleSubmit ===
 const handleSubmit = async () => {
  // e.preventDefault();

 
  setIsSaving(true);

  try {
    const companyId =
      localStorage.getItem("company_id") ||
      localStorage.getItem("companyId");

    // Bank account selected from dropdown
    let bankId = "";

    try {
      const bankData = JSON.parse(debitAccount);
      bankId = bankData.id;
    } catch {
      bankId = debitAccount;
    }

    const formData = new FormData();

    formData.append("company_id", companyId);
    formData.append("member_name", selectedPaymentType); // Member ID
    formData.append("loan_name", selectedLoanProducts); // Loan Product ID
    formData.append("transaction_date", transactionDate);
    formData.append("currency", selectedCurrency);
    formData.append("loan_interest", loanInterest);
    formData.append(
      "principal_amount",
      Number(String(totalAmount || "0").replace(/,/g, ""))
    );
    formData.append(
      "interest_amount",
      Number(String(interestAmount || "0").replace(/,/g, ""))
    );
    formData.append(
      "total_repayment",
      Number(String(repaymentAmount || "0").replace(/,/g, ""))
    );
    formData.append("duration", duration);
    formData.append(
      "monthly_deduction",
      Number(String(monthlyDeduction || "0").replace(/,/g, ""))
    );
    formData.append("bank", bankId);
    formData.append("reference_number", description);
    if (supportingDocument) {
    formData.append("file", supportingDocument);
}

    console.log("Loan Application Payload");

    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await api.post(
      "/v1/member_loan_application",
      withCompanyId(formData),
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        imageUrl: verified,
        title: "Loan Application Submitted",
        text:
          response.data?.message ||
          "Loan application submitted successfully.",
        confirmButtonColor: "#16A34A",
      }).then(() => {
        resetFormFields();

        if (onSuccess) {
          onSuccess();
        }

       
      });
    }
     onClose();
  } catch (error) {
    console.error(error);
    alert(typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message)
              .flat()
              .join(", ")
          : error.response?.data?.message ||
            "An error occurred while submitting the application.",)

    Swal.fire({
      imageUrl: crop,
      title: "Submission Failed",
      text:
        typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message)
              .flat()
              .join(", ")
          : error.response?.data?.message ||
            "An error occurred while submitting the application.",
    });
  } finally {
    setIsSaving(false);
  }
};

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem'
        }}>

        <h3 className={classes.title}>Upload Loan Application (Excel Format)</h3>
        <h3 className={classes.titlers}>Download Template</h3>
        </div>
        <div className={classes.topRow}>
          <div className={classes.Group3}>
            <label>File</label>
         <input
  type="file"
  accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
  onChange={handleFileChange}
  // className={classes.fileInput}
/>
          {/* {supportingError && (<div style={{ color: 'red', marginTop: 6 }}>{supportingError}</div>)}
          {supportingDocument && (
            <div style={{ marginTop: 6 }}>
              {supportingDocument.name} <button type="button" onClick={() => { setSupportingDocument(null); setSupportingError(""); }}>Remove</button>
            </div>
          )} */}
          </div>
          <div className={classes.Group3}>
            <label>Loan Product</label>
           <select
  value={selectedLoanProducts}
  onChange={(e) => {
    const selectedId = e.target.value;

    setSelectedLoanProducts(selectedId);

    const selectedLoan = loanProducts.find(
      (loan) => loan.id.toString() === selectedId
    );

    if (selectedLoan) {
      setFetchedLoanInterest(selectedLoan.interest_rate);
      setLoanInterest(selectedLoan.interest_rate);
    }
  }}
>
  <option value="">Select Product</option>
  {loanProductsLoading ? (
    <option>Loading products...</option>
  ) : (
    loanProducts.map((type) => {
      const name = type.loan_name || type.type_name;

      return (
        <option key={type.id} value={type.id}>
          {name}
        </option>
      );
    })
  )}
</select>
          </div>
          <div className={classes.Group}>
            <label>Date</label>
            <input
              type="date"
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              required
            />
          </div>

          <div className={classes.Group}>
            <label>Currency</label>
            <select
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
            >
              <option value="">Select Currency</option>
              {currencyOptions.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.code || c.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={classes.topRows}>
          {/* <div className={classes.Group2}>
            <label>Loan Interest</label>
            <input
              type="number"
              placeholder="Enter Loan Interest"
              style={{ textAlign: "left" }}
              value={loanInterest}
              onChange={(e) => setLoanInterest(e.target.value)}
            />
          </div>
          <div className={classes.Group1}>
            <label>Principal Amount</label>
             <CurrencyInput
              name="principal amount"
                                        
                                        decimalsLimit={2}
                                        style={{height: 20, textAlign: 'right'}}
                                        value={totalAmount} 
             onValueChange={handleValueChange}
            />
          </div>
          <div className={classes.Group2}>
            <label>Interest Amount</label>
             <CurrencyInput
              name="interest amount"
                                        disabled
                                        decimalsLimit={2}
                                        style={{height: 20, textAlign: 'right'}}
                                        value={interestAmount} 
             onValueChange={handleValueChange1}
            />
          </div>
          <div className={classes.Group2}>
            <label>Total Repayment</label>
             <CurrencyInput
              name="total repayment"
              disabled
                                        
                                        decimalsLimit={2}
                                        style={{height: 20, textAlign: 'right'}}
                                        value={repaymentAmount} 
             onValueChange={handleValueChange2}
            />
          </div> */}
          {/* <div className={classes.Group1}>
            <label>Description</label>
            <input
              type="text"
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div> */}

          {/* <div className={classes.Group2}>
            <label>Mode of Payment</label>
            <div className={classes.searchableDropdown}>
              <input
                type="text"
                placeholder="Search or select payment mode..."
                value={paymentSearch}
                onChange={(e) => setPaymentSearch(e.target.value)}
                onFocus={() => setShowPaymentDropdown(true)}
                onClick={() => setShowPaymentDropdown(!showPaymentDropdown)}
                className={classes.accountInput}
              />

              {showPaymentDropdown && (
                <div
                  className={classes.dropdownList}
                  onMouseLeave={() => setShowPaymentDropdown(false)}
                >
                  {paymentModes.length === 0 ? (
                    <div>No payment modes found</div>
                  ) : (
                    paymentModes
                      .filter((m) =>
                        (m.name || m.method_name || "").toLowerCase().includes(paymentSearch.toLowerCase())
                      )
                      .map((m) => (
                        <div
                          key={m.id}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setSelectedPaymentMode(m.id);
                            setPaymentSearch(m.name || m.method_name || "");
                            setShowPaymentDropdown(false);
                          }}
                        >
                          {m.name || m.method_name}
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div> */}

         
        </div>

        <div className={classes.top}>
          {/* <div className={classes.Group2}>
            <label>Duration(Months)</label>
            <input
              type="number"
              placeholder="Enter Duration in Months"
              style={{ textAlign: "left" }}
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
            />
          </div>
          <div className={classes.Group2}>
            <label>Monthly Deduction</label>
             <CurrencyInput
              name="monthly deduction"
                                        
                                        decimalsLimit={2}
                                        disabled
                                        style={{height: 20, textAlign: 'right'}}
                                        value={monthlyDeduction} 
             onValueChange={handleValueChange3}
            />
          </div> */}

           <div className={classes.Group2}>
            <label>Bank Account</label>
            <div className={classes.searchableDropdown}>
              <input
                type="text"
                placeholder="Search or select debit account..."
                value={debitSearch}
                onChange={(e) => setDebitSearch(e.target.value)}
                onFocus={() => setShowDebitDropdown(true)}
                onClick={() => setShowDebitDropdown(!showDebitDropdown)}
                className={classes.accountInput}
                disabled={debitAccountsLoading}
              />

              {showDebitDropdown && (
                <div
                  className={classes.dropdownList}
                  onMouseLeave={() => setShowDebitDropdown(false)}
                >
                  {debitAccountsLoading ? (
                    <div>Loading accounts...</div>
                  ) : creditAccounts.length === 0 ? (
                    <div>No accounts found</div>
                  ) : (
                    creditAccounts
                      .filter((acc) =>
                        (acc.label || "").toLowerCase().includes(debitSearch.toLowerCase())
                      )
                      .map((acc) => (
                        <div
                          key={acc.value}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setDebitAccount(JSON.stringify({ id: acc.value, gl_code: acc.gl_code }));
                            setDebitSearch(acc.label || "");
                            setShowDebitDropdown(false);
                          }}
                        >
                          {acc.label}
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div>

          {/* <div className={classes.Group2}>
            <label>Loan Account</label>
            <select
              value={selectedLoanAccount}
              onChange={(e) => setSelectedLoanAccount(e.target.value)}
              disabled
            >
              <option value="">Select Loan Account (Coming Soon)</option>
              <option value="loan-1">Loan #001 - Placeholder</option>
              <option value="loan-2">Loan #002 - Placeholder</option>
            </select>
          </div> */}

          <div className={classes.Group2}>
            <label>Reference/Loan No.</label>
            <input
              type="text"
              placeholder="Enter reference number"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          {(() => {
            const selectedModeName = paymentModes.find(
              (m) => m.id == selectedPaymentMode
            )?.name?.toLowerCase();

            if (selectedModeName?.includes("loan")) {
              return (
                <div className={classes.Group2}>
                  <label>Outstanding</label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={outstandingAmount || ""}
                    disabled
                  />
                </div>
              );
            }
            return null;
          })()}
        </div>

        {/* <div className={classes.Group2}>
          <label>Supporting Document</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            className={classes.fileInput}
          />
          {supportingError && (<div style={{ color: 'red', marginTop: 6 }}>{supportingError}</div>)}
          {supportingDocument && (
            <div style={{ marginTop: 6 }}>
              {supportingDocument.name} <button type="button" onClick={() => { setSupportingDocument(null); setSupportingError(""); }}>Remove</button>
            </div>
          )}
        </div> */}

        {/* <table className={classes.table}>
          <thead>
            <tr>
              <th>#</th>
              <th>Account Name</th>
              <th>Account Code</th>
              <th>Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td className={classes.accountCell}>
                  <div className={classes.searchableDropdown}>
                    <input
                      type="text"
                      value={row.accountDisplay}
                      onChange={(e) => handleChange(index, "accountDisplay", e.target.value)}
                      onFocus={() => handleChange(index, "showDropdown", true)}
                      onClick={() =>
                        handleChange(index, "showDropdown", !row.showDropdown)
                      }
                      placeholder="Search or type account..."
                      className={classes.accountInput}
                    />

                    {row.showDropdown && (
                      <div
                        className={classes.dropdownList}
                        onMouseLeave={() => handleChange(index, "showDropdown", false)}
                      >
                        {paymentTypeLower.includes("payable") ? (
                          payableAccountsLoading ? (
                            <div className={classes.dropdownLoading}>
                              <Spinner animation="border" size="sm" />
                            </div>
                          ) : (
                            payableAccounts
                              .filter((acc) => {
                                const search = row.accountDisplay?.toLowerCase() || "";
                                const text = `${acc.gl_code ?? acc.code ?? ""} ${acc.gl_name ?? acc.name ?? acc.account_name ?? ""
                                  }`.toLowerCase();
                                return text.includes(search);
                              })
                              .map((acc) => (
                                <div
                                  key={acc.id}
                                  className={classes.dropdownItem}
                                  onClick={() => handleChange(index, "account", acc)}
                                >
                                  {`${acc.gl_code ?? acc.code ?? ""} - ${acc.gl_name ?? acc.name ?? acc.account_name ?? ""
                                    }`}
                                </div>
                              ))
                          )
                        ) : (
                          accountsLoading ? (
                            <div className={classes.dropdownLoading}>
                              <Spinner animation="border" size="sm" />
                            </div>
                          ) : (
                            accounts
                              .filter((acc) => {
                                const search = row.accountDisplay?.toLowerCase() || "";
                                const text = `${acc.gl_code ?? acc.code ?? ""} ${acc.gl_name ?? acc.name ?? ""
                                  }`.toLowerCase();
                                return text.includes(search);
                              })
                              .map((acc) => (
                                <div
                                  key={acc.id}
                                  className={classes.dropdownItem}
                                  onClick={() => handleChange(index, "account", acc)}
                                >
                                  {`${acc.gl_code ?? acc.code ?? ""} - ${acc.gl_name ?? acc.name ?? ""
                                    }`}
                                </div>
                              ))
                          )
                        )}
                      </div>
                    )}
                  </div>
                </td>

                <td>
                  <input
                    type="text"
                    value={row.accountCode}
                    readOnly
                    className={classes.readOnlyInput}
                  />
                </td>

                <td>
                  <input
                    type="number"
                    className={classes.creditInput}
                    value={row.amount}
                    onChange={(e) =>
                      handleChange(index, "amount", e.target.value)
                    }
                  />
                </td>

                <td>
                  <button
                    onClick={() => duplicateRow(index)}
                    className={classes.linkBtn}
                    disabled={paymentTypeLower.includes("supplier")}
                    style={{
                      opacity: paymentTypeLower.includes("supplier") ? 0.6 : 1,
                      cursor: paymentTypeLower.includes("supplier") ? "not-allowed" : "pointer",
                    }}
                  >
                    Duplicate
                  </button>
                  <button
                    onClick={() => removeRow(index)}
                    className={classes.removeBtn}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}

        {/* <div className={classes.actionRow}>
          <button className={classes.addLineBtn} onClick={addLine}>
            + Add Line
          </button>
        </div> */}

        {/* <div className={classes.totalRow}>
          <div className={classes.totalBox}>
            <span>Total Debit</span>
            <strong>{totalDebit.toFixed(2)}</strong>
          </div>
          <div className={classes.totalBox}>
            <span>Total Credit</span>
            <strong>{totalCredit.toFixed(2)}</strong>
          </div>
        </div> */}

        <form >
          <div className={classes.footerButtons}>
            <button
              type="button"
              className={classes.resetBtn}
              onClick={resetFormFields}
            >
              Reset
            </button>

            {/* <button type="button" className={classes.printBtn} onClick={handlePrinter}>
              Print
            </button> */}

            <Button
              variant="success"
              className={classes.submitBtn}
              disabled={isSaving}
              onClick={() => {handleSubmit()}}
            >
              {isSaving ? (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  <Spinner animation="border" size="sm" /> Saving...
                </span>
              ) : (
                "Save Payment"
              )}
            </Button>
          </div>
        </form>

        <button className={classes.closeBtn} onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
}

export default LoanAppModalExcel;